export default "__VITE_ASSET__B9mTKvA3__"